import React, { useEffect, useState } from "react";
import "react-calendar/dist/Calendar.css";
import { Row, Col } from "react-bootstrap";
import Footer from "./footer";
import Header from "./header";
import { Link, useNavigate } from "react-router-dom";
import {  teacherlist } from "../service/dashboard";

const TeacherList = () => {
    const navigate = useNavigate();
    const [slist, setSList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);

    // Filters
    const [searchName, setSearchName] = useState("");
    const [searchClass, setSearchClass] = useState("");
    const [searchSection, setSearchSection] = useState("");

    const studentsPerPage = 6; // little more for grid

    useEffect(() => {
        teacherlist(1).then((res) => {
            if (res.status === true) {
                setSList(res.data.details);
            }
        });
    }, []);

    // Filter
    const filteredStudents = slist.filter((student) => {
        return (
            student.teacher_name?.toLowerCase().includes(searchName.toLowerCase()) &&
            student.class_name?.toLowerCase().includes(searchClass.toLowerCase()) &&
            student.section_name?.toLowerCase().includes(searchSection.toLowerCase())
        );
    });

    // Pagination
    const indexOfLast = currentPage * studentsPerPage;
    const indexOfFirst = indexOfLast - studentsPerPage;
    const currentStudents = filteredStudents.slice(indexOfFirst, indexOfLast);
    const totalPages = Math.ceil(filteredStudents.length / studentsPerPage);
    // Image fallback
    function errorphoto(ev) {
        ev.target.src = require("../assets/images/teacher.jpg");
        ev.target.onerror = null;
    }

    return (
        <div id="mainpage">
            <div className="maincontent">
                <Header />
                <div className="moreheading">
                    <Row className="row-sm">

                        <Col xs={6} className="text-left align-self-end">
                            <h4 className="morehead-text">Teacher List</h4>
                        </Col>
                        
                        <Col xs={6} className="text-right align-self-end">
                            <Link to={"/dashboard"} className="btn-outline-success red-btn btn-sm">
                                <i className="fa-solid fa-hand-point-left"></i> Go Back
                            </Link>
                        </Col>

                    </Row>
                </div>
                {/* ================= FILTER ================= */}
                <div className="card p-3 mb-3">
                    <Row>
                        <Col xs={12} md={4}>
                            <input
                                type="text"
                                className="form-control mt-1"
                                placeholder="Search by Name"
                                value={searchName}
                                onChange={(e) => {
                                    setSearchName(e.target.value);
                                    setCurrentPage(1);
                                }}
                            />
                        </Col>

                        <Col xs={12} md={4}>
                            <input
                                type="text"
                                className="form-control mt-1"
                                placeholder="Search by Class"
                                value={searchClass}
                                onChange={(e) => {
                                    setSearchClass(e.target.value);
                                    setCurrentPage(1);
                                }}
                            />
                        </Col>

                        <Col xs={12} md={4}>
                            <input
                                type="text"
                                className="form-control mt-1"
                                placeholder="Search by Section"
                                value={searchSection}
                                onChange={(e) => {
                                    setSearchSection(e.target.value);
                                    setCurrentPage(1);
                                }}
                            />
                        </Col>
                    </Row>

                    <div className="text-end mt-2">
                        <button
                            className="btn btn-sm btn-secondary"
                            onClick={() => {
                                setSearchName("");
                                setSearchClass("");
                                setSearchSection("");
                                setCurrentPage(1);
                            }}
                        >
                            Clear Filters
                        </button>
                    </div>
                </div>

                {/* ================= CARD GRID (ALL DEVICES) ================= */}
                <Row className="mt-3">
                    {currentStudents.length > 0 ? (
                        currentStudents.map((student) => (
                            <Col
                                key={student.id}
                                xs={12}
                                sm={6}
                                md={6}
                                lg={4}
                                xl={3}
                                className="mb-3"
                            >
                                <div className="card shadow-sm h-100">
                                    <div className="card-body">

                                        {/* Top */}
                                        <div className="d-flex align-items-center mb-2">
                                            <img
                                                src={student.path + student.photo}
                                                onError={errorphoto}
                                                alt="student"
                                                className="rounded-circle me-3"
                                                style={{ height: "60px", width: "60px" }}
                                            />

                                            <div>
                                                <h6 className="mb-0">{student.teacher_name}</h6>
                                                <small className="text-muted">
                                                    {student.username}
                                                </small>
                                            </div>
                                        </div>

                                        {/* Info */}
                                        <p className="mb-1"><strong>Incharge Class:</strong> {student.class_name}</p>
                                        <p className="mb-1"><strong>Section:</strong> {student.section_name}</p>
                                        <p className="mb-1"><strong>Mobile:</strong> {student.phone}</p>
                                        <p className="mb-1"><strong>Qualification:</strong> {student.qual_name}</p>
                                        <p className="mb-2"><strong>Academy:</strong> {student.academy_name}</p>

                                        {/* Action */}
                                        <button
                                            onClick={() => navigate(`/teacher-profile/${student.id}`)}
                                            className="btn btn-sm btn-success w-100"
                                        >
                                            View Profile
                                        </button>
                                    </div>
                                </div>
                            </Col>
                        ))
                    ) : (
                        <Col>
                            <p className="text-center mt-3">No teachers found</p>
                        </Col>
                    )}
                </Row>

                {/* ================= PAGINATION ================= */}
                <div className="d-flex justify-content-center align-items-center mt-3 mb-4">
                    <button
                        className="btn btn-sm btn-outline-primary me-2"
                        disabled={currentPage === 1}
                        onClick={() => setCurrentPage(currentPage - 1)}
                    >
                        Prev
                    </button>

                    <span>
                        Page {currentPage} of {totalPages || 1}
                    </span>

                    <button
                        className="btn btn-sm btn-outline-primary ms-2"
                        disabled={currentPage === totalPages || totalPages === 0}
                        onClick={() => setCurrentPage(currentPage + 1)}
                    >
                        Next
                    </button>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default TeacherList;